import React, { Fragment, useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "./calendar.css";
import { CloudCog } from "lucide-react";

const BookingCalendar = ({
  events = [],
  crews = [],
  allCrews = [],
  date,
  height = "auto",
  onAppointmentClick,
  startTime = "08:00",
  endTime = "20:00",
  datesSet = () => {},
  editable,
  headerToolbar = false,
  copy = false,
  closeCalendarFUN,
  submitEnabled = false,
  onSubmit,
  // Width reserved per provider column; the grid scrolls sideways once providers outgrow the view.
  columnMinWidth = 270,
}) => {
  const [textCopy, setTextCopy] = useState("Copy");
  const calendarRef = useRef(null);
  const scrollRef = useRef(null);
  const submitEnabledRef = useRef(submitEnabled);

  console.log("submitEnabled---", submitEnabled);

  let workers = [];

  const isFilterApplied = crews?.length > 0;

  const MAX_VISIBLE = 5;

  const [startIndex, setStartIndex] = useState(0);

  const crewMap = {};

  crews?.forEach((crew) => {
    if (!crewMap[crew.user_id]) {
      crewMap[crew.user_id] = {
        id: crew.first_name,
        title: crew.first_name,
        services: new Set(),
      };
    }

    if (crew.service_name) {
      if (Array.isArray(crew.service_name)) {
        crew.service_name.forEach((s) => crewMap[crew.user_id].services.add(s));
      } else {
        crewMap[crew.user_id].services.add(crew.service_name);
      }
    }
  });

  const crewList = Object.values(crewMap).map((c) => ({
    id: c.id,
    title: c.title,
    service_name: [...c.services].join(", "),
  }));

  // event ids
  const eventWorkerIds =
    events?.flatMap((e) => e?.resourceId?.split(",").map((r) => r.trim())) ||
    [];

  const eventIdSet = new Set(eventWorkerIds);

  if (isFilterApplied) {
    workers = crewList.map((crew) => ({
      id: crew.id,
      title: crew.title,
      service_name: crew.service_name, // no booking → show service
    }));
  } else if (eventWorkerIds.length === 0) {
    workers = (crews?.length ? crewList : []).map((crew) => ({
      id: crew.id,
      title: crew.title,
      service_name: crew.service_name,
    }));
  } else {
    // Build service names per crew from event extendedProps
    const workerServiceMap = {};
    events.forEach((event) => {
      const ids = (event?.resourceId || "")
        .split(",")
        .map((r) => r.trim())
        .filter(Boolean);
      ids.forEach((id) => {
        if (!workerServiceMap[id]) workerServiceMap[id] = new Set();
        const s =
          event.extendedProps?.service_name ||
          event.extendedProps?.extendedProps?.service_name ||
          event.extendedProps?.service_offering_name ||
          event.extendedProps?.extendedProps?.service_offering_name ||
          "";
        if (s) workerServiceMap[id].add(s);
      });
    });

    workers = Array.from(eventIdSet).map((id) => ({
      id,
      title: id,
      service_name: [...(workerServiceMap[id] || new Set())].join(", "),
    }));
  }
  const visibleWorkers = workers;

  useEffect(() => {
    setStartIndex(0);
  }, [crews, events]);
  // const workers = [...new Set(events.map((e) => e.resourceId))].map((id) => ({
  //   id,
  //   title: id,
  // }));

  // let workers = [];

  // if (events?.length > 0) {
  //   workers = [
  //     ...new Set(
  //       events?.flatMap((e) =>
  //         e?.resourceId?.split(",").map((r) => r.trim())
  //       )
  //     ),
  //   ].map((id) => ({
  //     id,
  //     title: id,
  //   }));
  // }
  // else if (crews?.length > 0) {
  //   workers = crews.map((crew) => ({
  //     id: crew.first_name, // or crew.id if needed
  //     title: crew.first_name,
  //     service_name: crew.service_name,
  //   }));
  // }
  // let workers = [];

  // const isFilterApplied = crews && crews.length > 0;

  // // crew list (ONLY when filter applied)
  // const crewList =
  //   crews?.map((crew) => ({
  //     id: crew.first_name,
  //     title: crew.first_name,
  //     service_name: crew.service_name,
  //   })) || [];

  // // event ids
  // const eventWorkerIds =
  //   events?.flatMap((e) =>
  //     e?.resourceId?.split(",").map((r) => r.trim())
  //   ) || [];

  // const eventIdSet = new Set(eventWorkerIds);

  // if (isFilterApplied) {
  //   workers = crewList.map((crew) => ({
  //     id: crew.id,
  //     title: crew.title,
  //     service_name: eventIdSet.has(crew.id)
  //       ? ""
  //       : crew.service_name,
  //   }));
  // }

  // else if (eventWorkerIds.length === 0) {
  //   // ⚠️ IMPORTANT: use ALL CREWS here
  //  workers = allCrews.map((crew) => ({
  //   id: crew.first_name,
  //   title: crew.first_name,
  //   service_name: crew.service_name,
  // }));
  // }

  // else {
  //   workers = Array.from(eventIdSet).map((id) => ({
  //     id,
  //     title: id,
  //     service_name: "",
  //   }));
  // }
  const getStatusColors = (status) => {
    // Define color schemes for different statuses with requested light colors
    const statusColors = {
      // Pending/Upcoming (10) - Light yellow
      10: {
        bgColor: "#FDEDED",
        borderColor: "#FF0000",
        textColor: "#FF0000",
      },

      // Completed/Checked Out (15) - Light green
      1: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },

      // Checked In (11) - Light blue
      2: {
        bgColor: "#FFF0FD",
        borderColor: "#92007E",
        textColor: "#92007E",
      },
      // Cancelled (14) - Light red
      3: {
        bgColor: "rgba(255, 204, 204, 0.5)",
        borderColor: "#CC0000",
        textColor: "#990000",
      },
      4: {
        bgColor: "rgba(255, 255, 204, 0.5)",
        borderColor: "#CCCC00",
        textColor: "#666600",
      },
      // No Show (15) - Light orange
      12: {
        bgColor: "F2F9FF",
        borderColor: "#037FE8",
        textColor: "#037FE8",
      },

      // Default - Light gray
      default: {
        bgColor: "rgba(230, 230, 230, 0.5)",
        borderColor: "#999999",
        textColor: "#666666",
      },
    };

    return statusColors[status] || statusColors.default;
  };

  function formatTimeForCalendar(timeString, addHour = false) {
    const fallback = addHour ? "21:00:00" : "08:00:00";
    if (!timeString) return fallback;

    timeString = timeString.toString().replace(/[AP]M/i, "").trim();
    let [hours, minutes] = timeString.split(":");
    hours = parseInt(hours, 10);
    minutes = minutes ? parseInt(minutes, 10) : 0;

    if (isNaN(hours) || isNaN(minutes)) return fallback;

    if (addHour) {
      hours += 1;
      if (hours >= 24) {
        hours = 23;
        minutes = 59;
      }
    }

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:00`;
  }

  const formattedStart = formatTimeForCalendar(startTime);
  const formattedEnd = formatTimeForCalendar(endTime, true);

  const formattedEvents = events.flatMap((event) => {
    const resources = event?.resourceId?.split(",").map((r) => r.trim());

    // If only one crew → return as is
    if (resources?.length === 1) {
      return event;
    }

    // If multiple crews → duplicate event per crew
    return resources?.map((res) => ({
      ...event,
      resourceId: res, // ✅ assign single resource
    }));
  });

  const filteredEvents = formattedEvents.filter((event) => {
    if (!event?.start || !event?.end) return false;

    const eventStart =
      new Date(event?.start).getHours() +
      new Date(event?.start).getMinutes() / 60;
    const eventEnd =
      new Date(event?.end).getHours() + new Date(event?.end).getMinutes() / 60;
    const calendarStart =
      parseInt(formattedStart.split(":")[0]) +
      parseInt(formattedStart.split(":")[1]) / 60;
    const calendarEnd =
      parseInt(formattedEnd.split(":")[0]) +
      parseInt(formattedEnd.split(":")[1]) / 60;

    const duration = (eventEnd - eventStart) * 60;
    return (
      duration >= 15 && eventStart >= calendarStart && eventEnd <= calendarEnd
    );
  });

  // const filteredEvents = events;
  function copyItem(e, eventInfo) {
    e.stopPropagation();
    let { timeText, event } = eventInfo;
    // console.log("event-------", event);

    let d1 = "";

    if (event?.startStr) {
      d1 += `Date: ${event?.startStr?.split("T")[0]} \n`;
    }
    if (timeText) {
      d1 += `Time: ${timeText} \n`;
    }

    if (event.title) {
      d1 += `Crew: ${event.title} \n`;
    }

    if (event?.extendedProps?.partner_name) {
      d1 += `Profile: ${event?.extendedProps?.partner_name} \n`;
    }

    if (event?.extendedProps?.group_id) {
      d1 += `Booking ID: ${event?.extendedProps?.display_booking_id} \n`;
    }

    if (event?.extendedProps?.service_name) {
      d1 += `Service: ${event?.extendedProps?.service_name} \n`;
    }

    if (event?.extendedProps?.service_offering_name) {
      d1 += `Type: ${event?.extendedProps?.service_offering_name} \n`;
    }

    if (event?.extendedProps?.house_no) {
      d1 += `Address: ${event?.extendedProps?.house_no} ${event?.extendedProps?.area}
          ${event?.extendedProps?.location} ${event?.extendedProps?.landmark} \n`;
    }

    if (event?.extendedProps?.state) {
      d1 += `Location: ${event?.extendedProps?.state} \n`;
    }

    if (event?.extendedProps?.user_name) {
      d1 += `Customer Name: ${event?.extendedProps?.user_name} \n`;
    }

    if (event?.extendedProps?.phone_number) {
      d1 += `Customer Contact: ${event?.extendedProps?.phone_number} \n`;
    }

    console.log("d10-----", d1);

    copyToClipboard(d1);
  }

  const copyToClipboard = (text) => {
    setTextCopy("Copied.");
    setTimeout(() => {
      setTextCopy("Copy");
    }, 200);
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("Copied!");
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  function renderEventContent(eventInfo) {
    return (
      <CalendarEvent
        eventInfo={eventInfo}
        copy={copy}
        textCopy={textCopy}
        copyItem={copyItem}
        getStatusColors={getStatusColors}
      />
    );
  }
  const CalendarEvent = ({
    eventInfo,
    copy,
    textCopy,
    copyItem,
    getStatusColors,
  }) => {
    const { timeText, event } = eventInfo;
    const eventRef = useRef(null);

    const status = event.extendedProps?.status;

    const statusColors = getStatusColors(status);
    const statusName = event.extendedProps?.status_name || "";

    useEffect(() => {
      if (!eventRef.current) return;

      const el = eventRef.current;

      if (el.scrollHeight > el.clientHeight) {
        el.classList.add("has-overflow");
      } else {
        el.classList.remove("has-overflow");
      }
    }, []);

    const isGreaterThanTwoHours = (e) => {
      let { startStr, endStr } = e;
      startStr = startStr.split("T")[1];
      endStr = endStr.split("T")[1];

      const toMinutes = (time) => {
        const [h, m] = time.split(":").map(Number);
        return h * 60 + (m || 0);
      };

      const duration = toMinutes(endStr) - toMinutes(startStr);

      return duration >= 120; // 120 mins = 2 hours
    };

    return (
      <div className="hoverCalendarBox">
        <div
          ref={eventRef}
          className={`custom-event d-flex flex-column  ${
            // status === 1 ? "" : ""
            status === 1 ? "visibilityHidden" : ""
          }`}
        >
          <div className="event-time d-flex justify-content-between">
            <div>
              {timeText}
              {statusName && (
                <span
                  className="event-status"
                  style={{
                    backgroundColor: "#ffffff",
                    color: "#666666",
                    border: `1px solid #999999`,
                    padding: "0px 8px",
                    borderRadius: "12px",
                    fontSize: "0.75rem",
                    marginLeft: "6px",
                  }}
                >
                  {statusName ? statusName : ""}
                </span>
              )}
            </div>

            {copy && (
              <div onClick={(e) => copyItem(e, eventInfo)} className="copyItem">
                {textCopy}
              </div>
            )}
          </div>
          {isGreaterThanTwoHours(event) ? (
            <>
              <div>Crew: {event.title}</div>

              {event?.extendedProps?.partner_name && (
                <div>Profile: {event?.extendedProps?.partner_name}</div>
              )}

              {event?.extendedProps?.display_booking_id && (
                <div>
                  Booking ID: {event?.extendedProps?.display_booking_id}
                </div>
              )}

              {event?.extendedProps?.service_name && (
                <div>
                  Service category: {event?.extendedProps?.service_name}
                </div>
              )}

              {event?.extendedProps?.service_type_name && (
                <div>
                  Service Subcategory: {event?.extendedProps?.service_type_name}
                </div>
              )}

              {event?.extendedProps?.service_offering_name && (
                <div>
                  Service Type: {event?.extendedProps?.service_offering_name}
                </div>
              )}

              {event?.extendedProps?.user_name && (
                <div>Customer: {event?.extendedProps?.user_name}</div>
              )}

              {event?.extendedProps?.phone_number && (
                <div>Contact: {event?.extendedProps?.phone_number}</div>
              )}
            </>
          ) : (
            <>
              <div>Crew: {event.title}</div>
              <div
                style={{
                  backgroundColor: statusColors.bgColor,
                  color: statusColors.textColor,
                }}
                className="calendarData"
              >
                <>
                  {event?.extendedProps?.partner_name && (
                    <div>Profile: {event?.extendedProps?.partner_name}</div>
                  )}

                  {event?.extendedProps?.display_booking_id && (
                    <div>
                      Booking ID: {event?.extendedProps?.display_booking_id}
                    </div>
                  )}

                  {event?.extendedProps?.service_name && (
                    <div>Service: {event?.extendedProps?.service_name}</div>
                  )}

                  {event?.extendedProps?.service_type_name && (
                    <div>
                      Service Subcategory:{" "}
                      {event?.extendedProps?.service_type_name}
                    </div>
                  )}

                  {event?.extendedProps?.service_offering_name && (
                    <div>
                      Service Type:{" "}
                      {event?.extendedProps?.service_offering_name}
                    </div>
                  )}

                  {event?.extendedProps?.user_name && (
                    <div>Customer: {event?.extendedProps?.user_name}</div>
                  )}

                  {event?.extendedProps?.phone_number && (
                    <div>Contact: {event?.extendedProps?.phone_number}</div>
                  )}
                </>
              </div>
            </>
          )}
        </div>
      </div>
    );
  };

  // Normalize date to strict YYYY-MM-DD that FullCalendar can always parse.
  // Handles: undefined, "", null, Date objects, "YYYY-MM-DD HH:MM:SS" (space separator).
  const rawDate = date instanceof Date
    ? date
    : date ? new Date(String(date).replace(" ", "T")) : null;
  const safeDate = rawDate && !isNaN(rawDate.getTime())
    ? rawDate.toISOString().split("T")[0]
    : null;
  if (!safeDate) return null;

  return (
    <div className="calendar-container">
      <div ref={calendarRef}>
        <div className="calendar-scroll" ref={scrollRef}>
          <div
            style={{
              minWidth: `${workers.length * columnMinWidth}px`,
            }}
          >
            <div className="calendar-toolbar-fixed">
              <FullCalendar
                schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
                key={safeDate}
                plugins={[resourceTimeGridPlugin, interactionPlugin]}
                initialView="resourceTimeGridDay"
                resources={visibleWorkers}
                initialDate={safeDate}
                headerToolbar={
                  headerToolbar
                    ? {
                        left: "title",
                        // Submit only for callers that have something to submit (the legacy modal)
                        right: onSubmit ? "today prev,next submitButton" : "today prev,next",
                      }
                    : false
                }
                customButtons={{
                  submitButton: {
                    text: "Submit",
                    click: () => {
                      console.log(
                        "submitEnabledRef.current---",
                        submitEnabledRef.current,
                        submitEnabled
                      );
                      if (submitEnabled) onSubmit?.();
                    },
                  },
                }}
                eventOverlap={false}
                eventOrder="title"
                slotDuration="00:30:00"
                slotLabelFormat={{
                  hour: "numeric",
                  minute: "2-digit",
                  meridiem: "short",
                }}
                datesSet={(info) => datesSet(info)}
                allDaySlot={false}
                height={height}
                events={filteredEvents}
                slotMinTime={formattedStart}
                slotMaxTime={formattedEnd}
                editable={false}
                selectable={false}
                nowIndicator={false}
                dayHeaderFormat={{
                  weekday: "long",
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                }}
                contentHeight="auto"
                expandRows={true}
                eventContent={renderEventContent}
                eventClick={(info) => {
                  const details = info.event.extendedProps;
                  const appointment = { details };
                  if (onAppointmentClick) {
                    onAppointmentClick(appointment, date);
                  }
                }}
                resourceLabelContent={(arg) => {
                  const name = arg.resource.title || "";
                  const initial = name.charAt(0).toUpperCase();
                  const serviceName = arg.resource.extendedProps.service_name || "";
                  return {
                    html: `
                      <div class="crew-header-cell">
                        <div class="crew-avatar">${initial}</div>
                        <div class="crew-info">
                          <div class="crew-name">${name}</div>
                          ${serviceName ? `<div class="crew-service">${serviceName}</div>` : ""}
                        </div>
                      </div>
                    `,
                  };
                }}
              />
            </div>
          </div>
        </div>

        {/* <div className="calendar-nav">
      <button
        onClick={() => setStartIndex((prev) => Math.max(prev - MAX_VISIBLE, 0))}
        disabled={startIndex === 0}
      >
        ←
      </button>

      <button
        onClick={() =>
          setStartIndex((prev) =>
            prev + MAX_VISIBLE < workers.length ? prev + MAX_VISIBLE : prev
          )
        }
        disabled={startIndex + MAX_VISIBLE >= workers.length}
      >
        →
      </button>
    </div> */}
      </div>
    </div>
  );
};

export default BookingCalendar;
